import { makeStyles } from '@mui/styles';

export const PopperStyles = makeStyles<{}>({
  root: {
    zIndex: 10000,
  },
});
